import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgOpenShoes = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("g", {
		clipPath: "url(#clip0_1436_1260)",
		children: /* @__PURE__ */ _jsx("path", {
			d: "M20.9062 12.7998H14.1483L11.9374 8.33141C11.7992 8.05246 11.4725 7.92711 11.1859 8.04313L5.24841 10.4431C4.9726 10.554 4.82064 10.8542 4.89298 11.1451L5.30234 12.7998H3.09375C3.09399 12.7998 3.0935 12.7998 3.09375 12.7998C2.766 12.8 2.49981 13.0686 2.5 13.3998C2.5015 14.7247 3.56394 15.7983 4.875 15.7998H20.9062C20.906 15.7998 20.9065 15.7998 20.9062 15.7998C21.234 15.7996 21.5002 15.531 21.5 15.1998V13.3998C21.5 13.4001 21.5 13.3996 21.5 13.3998C21.4998 13.0687 21.234 12.7996 20.9062 12.7998ZM6.17035 11.362L11.1193 9.36154L12.8205 12.7998H6.52584L6.17035 11.362ZM20.3125 14.5998H4.875C4.45085 14.5998 4.05893 14.3711 3.84696 13.9998H20.3125V14.5998Z",
			fill: "currentColor"
		})
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_1436_1260",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 19,
			height: 8,
			fill: "white",
			transform: "translate(2.5 8)"
		})
	}) })]
});
export default SvgOpenShoes;
